const state = {
    list: JSON.parse(window.Laravel.notifications),
    unreadCount: JSON.parse(window.Laravel.unreadCount),
    noti: [
        {
            id: 1,
            selected: false,
            image: 'img/svg/hp-eagle.svg',
            name: 'Admin',
            message: 'Title notification goes here ipsum dolor lorem',
            created_at: '2020-11-23 10:15:55'
        },
        {
            id: 2,
            selected: true,
            image: 'img/svg/hp-eagle.svg',
            name: 'Admin',
            message: 'Title notification goes here ipsum dolor lorem',
            created_at: '2020-11-23 03:20:55'
        },
        {
            id: 3,
            selected: true,
            image: 'img/svg/hp-eagle.svg',
            name: 'Admin',
            message: 'Title notification goes here ipsum dolor lorem',
            created_at: '2020-11-22 22:32:55'
        },
        {
            id: 4,
            selected: true,
            image: 'img/svg/hp-eagle.svg',
            name: 'Admin',
            message: 'Title notification goes here ipsum dolor lorem',
            created_at: '2020-11-21 16:20:55'
        },
        {
            id: 5,
            selected: true,
            image: 'img/svg/hp-eagle.svg',
            name: 'Admin',
            message: 'Title notification goes here ipsum dolor lorem',
            created_at: '2020-11-10 09:20:55'
        },
    ]
};

const getters = {
    GET_NOTIFICATIONS_LIST: state => state.list,
    GET_NOTIFICATIONS_COUNT: state => state.unreadCount,
}

const mutations = {
    SET_NOTIFICATIONS_LIST (state, data) {
        state.list = data;
    }
};

const actions = {
    async ACT_NOTIFICATIONS_LIST ({commit}, data) {
        await commit('SET_NOTIFICATIONS_LIST', data);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}
